module.exports = __webpack_public_path__ + "img/scene-rockstar.6dffae1c.svg";